import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SearchCatalogForOrderGuideDocument = gql`
  query searchCatalogForOrderGuide(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $searchTerm: String!
  ) {
    searchCatalogForOrderGuideItems(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      search_term: $searchTerm
    ) {
      variant_pack_id
      item_info {
        image_url
        item_id
        name
      }
      pack_info {
        external_item_id
        max_unit_size
        min_unit_size
        unit
      }
    }
  }
`;
export function useSearchCatalogForOrderGuideQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SearchCatalogForOrderGuideQuery,
    Types.SearchCatalogForOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SearchCatalogForOrderGuideQuery,
    Types.SearchCatalogForOrderGuideQueryVariables
  >(SearchCatalogForOrderGuideDocument, options);
}
export function useSearchCatalogForOrderGuideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SearchCatalogForOrderGuideQuery,
    Types.SearchCatalogForOrderGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SearchCatalogForOrderGuideQuery,
    Types.SearchCatalogForOrderGuideQueryVariables
  >(SearchCatalogForOrderGuideDocument, options);
}
export type SearchCatalogForOrderGuideQueryHookResult = ReturnType<
  typeof useSearchCatalogForOrderGuideQuery
>;
export type SearchCatalogForOrderGuideLazyQueryHookResult = ReturnType<
  typeof useSearchCatalogForOrderGuideLazyQuery
>;
export type SearchCatalogForOrderGuideQueryResult = Apollo.QueryResult<
  Types.SearchCatalogForOrderGuideQuery,
  Types.SearchCatalogForOrderGuideQueryVariables
>;

/**
 * Wrapped version of useGeneratedSearchCatalogForOrderGuideQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSearchCatalogForOrderGuideQuery(
  options?: Apollo.QueryHookOptions<
    Types.SearchCatalogForOrderGuideQuery,
    Types.SearchCatalogForOrderGuideQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SearchCatalogForOrderGuideQuery,
    Types.SearchCatalogForOrderGuideQueryVariables
  >(SearchCatalogForOrderGuideDocument, options);
}

/**
 * Wrapped version of useGeneratedSearchCatalogForOrderGuideLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSearchCatalogForOrderGuideLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SearchCatalogForOrderGuideQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SearchCatalogForOrderGuideQuery,
    Types.SearchCatalogForOrderGuideQueryVariables
  >(SearchCatalogForOrderGuideDocument, lazyOptions);
}
